export default __webpack_public_path__ + "static/media/image-cover.5c8ce5dc.png";